import request from "@/utils/request";

// 查询字典
export const  queryDict =(query) =>{
    return request({
        url: "/businessservice/dict/queryDict",
        method:"get",
        params: query
    })
}

// 创建字典
export const  createDict =(data) =>{
    return request({
        url: "/businessservice/dict/createDict",
        method:"post",
        data: data
    })
}